import Swal from 'sweetalert2'

const swalContainerStyle = 'z-index: 1000001;'
const swalHeaderWithTitleStyle = 'color: #4B4B4B;padding: 2rem 2rem 1rem 2rem; margin-bottom: 2rem; border-top-left-radius: 10px; border-top-right-radius: 10px;background-color: #EFEFEF;'
const swalHeaderWithoutTitleStyle = 'height: 40px;'
const swalCloseButtonStyle = `
    color: #4B4B4B;
    margin: 1rem 1.5rem 0 0rem;
    font-weight: 600;
`
const swalCloseButtonStyleMobile = `
    color: rgb(75, 75, 75);
    margin: 2rem 1rem 0px 0rem;
    font-weight: 400;
    font-size: 30px;
`
const swalCloseButtonHiddenStyle = 'display: none;'
const swalContent = 'text-align: left;'

export const swalAlert =
    ({
         title,
         text,
         showCloseButton,
         showCancelButton,
         showDenyButton,
         focusConfirm,
         reverseButtons,
         cancelButtonText,
         confirmButtonText,
         customClass = {},
         denyButtonText,
         icon,
         colorIcon = 'inherit',
         sizeIcon = 'inherit',
         centerIcon = '',
         centerButton,
         hideHeader,
         textStyle,
         customWidth,
         customClose,
         preConfirm
     }) => {
        const swalTitle = title && !hideHeader ? `<div class='title'>${title}</div>`:''|| title ? `<div class='title'>${title}</div>` : ''
        const swalTitleHtml = textStyle ? `<span class='${textStyle}'>${text}</span>` : `<span class='content-text'>${text}</span>`
        const swalActions = `margin: 0; justify-content: ${centerButton ? 'center' : 'flex-end'};`
        const swalHeaderStyle = hideHeader ? swalHeaderWithoutTitleStyle : swalHeaderWithTitleStyle

        const classIcon = `${centerIcon ? 'center-icon' : ''}`

        const html = `${icon
            ? `<div class='${classIcon}'>
                    <i class='material-icons-outlined' style='color:${colorIcon}; font-size: ${sizeIcon};'>${icon}</i>
                </div>`
            : ''} 
            ${swalTitleHtml}`

        const isMobile = window.innerWidth <= 640


        return Swal.fire({
            title: swalTitle,
            html: html,
            padding: '0px',
            width: customWidth ? customWidth : '40rem',
            showCloseButton,
            showCancelButton,
            showDenyButton,
            focusConfirm,
            reverseButtons,
            cancelButtonText,
            confirmButtonText,
            denyButtonText,
            didClose: customClose,
            preConfirm,
            customClass: {
                ...customClass,
                container: `common-swal-alert ${customClass.container || ''}`
            },
            willOpen: () => {
                Swal.getContainer().style = swalContainerStyle
                Swal.getHeader().style = swalHeaderStyle
                Swal.getCloseButton().style = showCloseButton
                    ? isMobile ? swalCloseButtonStyleMobile : swalCloseButtonStyle
                    : swalCloseButtonHiddenStyle
                Swal.getActions().style = swalActions
                Swal.getContent().style = swalContent
            }
        })
    }
